import { render, staticRenderFns } from "./ClientContactsTable.vue?vue&type=template&id=04e94c61"
import script from "./ClientContactsTable.vue?vue&type=script&lang=js"
export * from "./ClientContactsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports